import * as z from "zod/v4";

export const addAiReturnReasonInput = {
  name: "addAiReturnReasonInput" as const,
  input: z.object({
    threadId: z.string().optional(),
    returnableItemId: z.string(),
    draftReturnId: z.string(),
    customerResponse: z.string(),
    flowStepIndex: z.number().optional(), // The index of the ai return reasons step so we can get the settings (in case they have 2 ai return reasons steps)
  }),
  output: z.object({
    threadId: z.string(),
    response: z.discriminatedUnion("type", [
      z.object({ type: z.literal("question"), question: z.string() }),
      z.object({
        type: z.literal("categorized"),
        categorizedReturnReason: z.string(),
        isDamaged: z.boolean(),
        isWrongProduct: z.boolean(),
      }),
    ]),
  }),
};
